var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import * as S from './styled';
const supportedHTMLElements = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'legend'];
export const Heading = (_a) => {
    var { type, weight = 'regular', asTag, children } = _a, props = __rest(_a, ["type", "weight", "asTag", "children"]);
    const getType = () => {
        if (asTag) {
            return asTag;
        }
        if (supportedHTMLElements.find((element) => element === type)) {
            return type;
        }
        return 'div';
    };
    return (React.createElement(S.Container, Object.assign({ as: getType(), "$type": type, "$weight": weight, "data-testid": "Heading" }, props), children));
};
//# sourceMappingURL=Heading.js.map